import { Component, Story } from './DocTypes';

const BarStory: Story = {
  title: 'Bar',
  description: 'A bar chart',
  coreComponent_v3: {
    html: `<tag3-chart height="300px" width="500px">,
</tag3-chart>`,
    js: `var chart = document.querySelector('tag3-chart');
chart.options = {
  title: {
    text: 'Sales this year',
  },
  xAxis: {
    data: ['Q1', 'Q2', 'Q3', 'Q4'],
  },
  yAxis: {},
  series: [
    {
      name: 'Sales',
      type: 'bar',
      data: [5, 20, 36, 20],
    },
  ],
}`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Chart
  height="300px"
  width="500px"
  options={{
    title: {
      text: 'Sales this year',
    },
    xAxis: {
      data: ['Q1', 'Q2', 'Q3', 'Q4'],
    },
    yAxis: {},
    series: [
      {
        name: 'Sales',
        type: 'bar',
        data: [5, 20, 36, 20],
      },
    ],
  }}
/>`,
  },
};

const PieStory: Story = {
  title: 'Pie',
  description: 'A pie chart',
  coreComponent_v3: {
    html: `<tag3-chart>,
</tag3-chart>`,
    js: `var chart = document.querySelector('tag3-chart');
chart.options = {
  title: {
    text: 'Sales this year',
  },
  series: [
    {
      name: 'Sales',
      type: 'pie',
      data: [
        {value: 5, name: 'Q1'},
        {value: 20, name: 'Q2'},
        {value: 36, name: 'Q3'},
        {value: 20, name: 'Q4'}
      ]
    },
  ],
}`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Chart
  options={{
    title: {
      text: 'Sales this year',
    },
    series: [
      {
        name: 'Sales',
        type: 'pie',
        data: [
          {value: 5, name: 'Q1'},
          {value: 20, name: 'Q2'},
          {value: 36, name: 'Q3'},
          {value: 20, name: 'Q4'}
        ]
      },
    ],
  }}
/>`,
  },
};

const LineStory: Story = {
  title: 'Line',
  description: 'A line chart',
  coreComponent_v3: {
    html: `<tag3-chart>,
</tag3-chart>`,
    js: `var chart = document.querySelector('tag3-chart');
chart.options = {
  title: {
    text: 'Sales this year',
  },
  tooltip: {},
  xAxis: {
    data: ['Q1', 'Q2', 'Q3', 'Q4'],
  },
  yAxis: {},
  series: [
    {
      name: 'Sales',
      type: 'line',
      data: [5, 20, 36, 20],
    },
  ],
}`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Chart
  options={{
    title: {
      text: 'Sales this year',
    },
    tooltip: {},
    xAxis: {
      data: ['Q1', 'Q2', 'Q3', 'Q4'],
    },
    yAxis: {},
    series: [
      {
        name: 'Sales',
        type: 'line',
        data: [5, 20, 36, 20],
      },
    ],
  }}
/>`,
  },
};

const ScatterStory: Story = {
  title: 'Scatter',
  description: 'A scatter chart',
  coreComponent_v3: {
    html: `<tag3-chart height="300px" width="600px">,
</tag3-chart>`,
    js: `var chart = document.querySelector('tag3-chart');
chart.options = {
  title: {
    text: 'Height / Weight',
  },
  legend: {},
  xAxis: {
    type: "value",
    scale: true,
    axisLabel: {
      formatter: "{value} cm"
    },
    splitLine: {
      show: false
    }
  },
  yAxis: {
    type: "value",
    scale: true,
    axisLabel: {
      formatter: "{value} kg"
    },
    splitLine: {
      show: false
    }
  },
  series: [{
    name: "Male",
    type: "scatter",
    data: [
      [174, 65.6],
      [175.3, 71.8],
      [193.5, 80.7],
      [186.5, 72.6],
      [187.2, 78.8],
      [184.9, 86.4],
      [177.3, 73.2],
      [167.4, 53.9],
      [178.1, 72],
      [185.4, 81.8],
      [185.4, 84.1],
      [188, 90.5],
      [188, 91.4],
      [182.9, 89.1],
      [176.5, 85],
      [175.3, 69.1],
      [175.3, 73.6],
      [188, 80.5],
      [167.6, 76.3],
      [183, 65.9],
      [183, 90.9],
      [179.1, 89.1],
      [170.2, 62.3],
      [177.8, 82.7],
      [179.1, 79.1],
      [190.5, 98.2],
      [177.8, 84.1],
      [180.3, 83.2],
      [180.3, 83.2]
    ]
  }]
}`,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Chart height="300px" width="600px"
  options={{
    title: {
      text: 'Height / Weight',
    },
    legend: {},
    xAxis: {
      type: "value",
      scale: true,
      axisLabel: {
        formatter: "{value} cm"
      },
      splitLine: {
        show: false
      }
    },
    yAxis: {
      type: "value",
      scale: true,
      axisLabel: {
        formatter: "{value} kg"
      },
      splitLine: {
        show: false
      }
    },
    series: [{
      name: "Male",
      type: "scatter",
      data: [
        [174, 65.6],
        [175.3, 71.8],
        [193.5, 80.7],
        [186.5, 72.6],
        [187.2, 78.8],
        [184.9, 86.4],
        [177.3, 73.2],
        [167.4, 53.9],
        [178.1, 72],
        [185.4, 81.8],
        [185.4, 84.1],
        [188, 90.5],
        [188, 91.4],
        [182.9, 89.1],
        [176.5, 85],
        [175.3, 69.1],
        [175.3, 73.6],
        [188, 80.5],
        [167.6, 76.3],
        [183, 65.9],
        [183, 90.9],
        [179.1, 89.1],
        [170.2, 62.3],
        [177.8, 82.7],
        [179.1, 79.1],
        [190.5, 98.2],
        [177.8, 84.1],
        [180.3, 83.2],
        [180.3, 83.2]
      ]
    }]
  }}
/>`,
  },
};

export const TagChartDocs: Component = {
  type: 'component',
  name: 'chart',
  description:
    'Renders a chart using the eChart library. For more details on the chart options, see https://echarts.apache.org',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'height',
      description: 'The height of the chart',
      type: 'string',
    },
    {
      name: 'width',
      description: 'The width of the chart',
      type: 'string',
    },
    {
      name: 'options',
      description: 'Valid eChart options',
      type: 'object',
    },
    {
      name: 'colourScheme',
      description:
        'V3 Only: Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'V3 Only: Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'chartClick',
      description: 'Raise when the chart is clicked',
      parameters: [
        {
          name: 'params',
          description:
            'Parameters from the eChart click event. See https://echarts.apache.org/en/api.html#events for more details',
          type: 'any',
        },
      ],
    },
  ],
  methods: [],
  stories: [BarStory, PieStory, LineStory, ScatterStory],
};
